<template>
    <div>
        <el-form inline>
            <el-form-item label="SKU">
                <el-input v-model="filters.Skus" placeholder="多个用逗号分开，单个的时候模糊查询" clearable  style="width:250px" ></el-input>
            </el-form-item>
            <el-form-item label="产品名称">
                <el-input v-model="filters.ProductName" placeholder="模糊查询" clearable></el-input>
            </el-form-item>
            
              <el-form-item label="状态">
                <el-select v-model="filters.ProductStatus" multiple="">
                    <el-option label="草稿" value="10"></el-option>
                    <el-option label="已审核" value="20"></el-option>
                </el-select>   
            </el-form-item>
         
             <el-form-item label="客户" v-show="searchConsumerVisible">
                    <el-select v-model="filters.CustomerIds"  placeholder="请选择客户"  multiple="">
                    <el-option
                        v-for="item in customerList"
                        :label="item.customName"
                        :value="item.id"
                        :key="item.id"
                    ></el-option>
                    </el-select>
      </el-form-item>

          </el-form>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        <!--列表-->
        <el-table-bar :fixed="true" :bottom="35">
          <el-table :data="tablelist" highlight-current-row
          @row-click="handleRowClick"
          border
          ref="multipleTable"
          v-loading="listLoading" @selection-change="selsChange"
                    style="width: 100%;">
              <el-table-column type="selection" width="50">
              </el-table-column> 
              <el-table-column prop="sku" label="sku" width="120px" >
              </el-table-column>
              <el-table-column prop="customName" label="客户"  width="120px" >
              </el-table-column>
              <el-table-column prop="productNameCN" label="产品名称" width="160px" >
              </el-table-column>
              <el-table-column prop="productStatusDesc" label="产品状态"  width="" >
              </el-table-column>
              <el-table-column prop="productAttribute" label="长/宽/高(cm)" width="150px" >
                  <template slot-scope="scope">
                    产品:{{scope.row.productLength}}/{{scope.row.productWidth}}/{{scope.row.productHight}}  <br>
                    包装:{{scope.row.packLength}}/{{scope.row.packWidth}}/{{scope.row.packHeight}}  <br>
                    外箱:{{scope.row.boxLength}}/{{scope.row.boxWidth}}/{{scope.row.boxHeight}}  <br>
            
                  </template>
              </el-table-column>
              <el-table-column prop="productWeight" label="净重/毛量(kg)" width="120px"   > 
                  <template slot-scope="scope">
                      {{scope.row.netWeight}}/{{scope.row.productWeight}} 
                  </template>
              </el-table-column>
               <el-table-column prop="boxNumber" label="单箱个数" width="" >
              </el-table-column>
              <el-table-column prop="brand" label="品牌" width="" >
              </el-table-column>
          
            <el-table-column prop="model" label="型号" width="" > 
              </el-table-column>

              <el-table-column prop="material" label="材质" width="" > 
              </el-table-column>

              <el-table-column prop="isHasAttach" label="认证文件" width="" >
                    <template slot-scope="scope">
                          <el-tag type="success"  v-if="!scope.row.isSaleCertificate" >不需要</el-tag>
                          <el-tag type="danger"  v-if="scope.row.isSaleCertificate" >需要</el-tag>
                          <el-button @click="manageAttach(scope.row.productId)" type="text"  v-if="scope.row.isHasAttach<=0&&scope.row.isSaleCertificate" size="small">未上传</el-button>
                          <el-button @click="manageAttach(scope.row.productId)" type="text" v-if="scope.row.isHasAttach>0&&scope.row.isSaleCertificate"  size="small">管理附件</el-button>
                    </template>
              </el-table-column>
              <el-table-column prop="hsCode" label="报关信息" width="160px" > 
                  <template slot-scope="scope"> 
                    <el-button click="" type="text" size="small" v-if="scope.row.hsCode!=null&&scope.row.hsCode.length>10"  @click="ShowHSCodeForm(scope.row)" :title="scope.row.hsCode" >{{scope.row.hsCode.slice(0,10)}}...</el-button>
                    <el-button click="" type="text" size="small" v-if="scope.row.hsCode!=null&&scope.row.hsCode.length<=10"  @click="ShowHSCodeForm(scope.row)" :title="scope.row.hsCode"  >{{scope.row.hsCode}}</el-button>
                  </template>
              </el-table-column>

          
              <el-table-column prop="productSKUUrl" label="产品链接" width="180px" > 
                 <template slot-scope="scope">
               
                    <el-link :href='scope.row.productSKUUrl' target="_blank" type="primary">{{ scope.row.productSKUUrl }}</el-link>
                  </template>
              </el-table-column>

              <el-table-column prop="createInfo" label="创建信息" width="200px"  > 
                      <template slot-scope="scope">
                      <p >{{ scope.row.createUser }}</p>
                      <p>{{scope.row.createTimeFormat}}</p>
                  </template>
              </el-table-column>

              <el-table-column prop="updateInfo" label="修改信息" width="200px"  :formatter="format_updateInfo" >
                    <template slot-scope="scope">
                      <p >{{ scope.row.lastUpUser }}</p>
                      <p> {{scope.row.lastUpTimeFormat}}</p>
                  </template> 
              </el-table-column>

              <el-table-column prop="checkInfo" label="审核信息" width="200px"   :formatter="format_checkInfo" > 
                    <template slot-scope="scope">
                      <p >{{ scope.row.checkUser }}</p>
                      <p>{{scope.row.checkTimeFormat}}</p>
                  </template> 
              </el-table-column>

          </el-table>
        </el-table-bar>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination 
            layout="total, sizes, prev, pager, next" 
            @current-change="handleCurrentChange" 
            @size-change="handleSizeChange"
            :page-size="50"
            :page-sizes="[10, 20, 50, 100]"
            :total="total" style="float:right;">
            </el-pagination>
        </el-col>
       


  <!-- 新增模块 -->
    <el-dialog title="新增"  
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
  <!-- 基本信息 -->
        <el-card shadow="hover">
          <div slot="header" class="clearfix" >
            <span>基本信息</span>
          </div>
          <el-row>
          <el-col :span="20">
            <el-form-item v-show="searchConsumerVisible"
              label="客户"
              prop="OrgId"
              class="labelcall"
              label-width="120px"
            >
              <el-select v-model="addForm.OrgId"  placeholder="请选择客户"  >
                    <el-option
                        v-for="item in customerEnabledList"
                        :label="item.customName"
                        :value="item.id"
                        :key="item.id"
                    ></el-option>
                    </el-select>
            </el-form-item>
          </el-col>
        
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="SKU"
              prop="SKU"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.SKU"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="SKUBarCode"
              label="条码"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="addForm.SKUBarCode"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>

    <el-row>
       <el-col :span="20">
            <el-form-item
              label="参考编号"
              prop="ReferenceNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ReferenceNumber"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>

        
        </el-row>


    <el-row>
       <el-col :span="20">
            <el-form-item
              label="名称【中文】"
              prop="ProductNameCN"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductNameCN"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>

<el-row>
       <el-col :span="20">
            <el-form-item
              label="名称【英文】"
              prop="ProductNameEN"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductNameEN"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>
        </el-card>
 

  <!-- 基本属性 -->
        <el-card shadow="hover" style="margin-top:10px;">
          <div slot="header" class="clearfix" >
            <span>基本属性</span>
          </div>
          <el-row>
          <el-col :span="12">
            <el-form-item
              label="品牌"
              prop="Brand"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Brand"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="NetWeight"
              label="净重(kg)"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="addForm.NetWeight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>    

          <el-row>
          <el-col :span="12">
            <el-form-item
              label="型号"
              prop="Model"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.Model"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="ProductWeight"
              label="毛重(kg)"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="addForm.ProductWeight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> 


             <el-row>
          <el-col :span="12">
            <el-form-item
              label="长(cm)"
              prop="ProductLength"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductLength"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="SalesStatus"
              label="销售状态"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
           <el-select v-model="addForm.SalesStatus" placeholder="请选择">
                <el-option
                v-for="item in options_salesStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
          </el-select>
            </el-form-item>
          </el-col>
        </el-row> 
         <el-row>
          <el-col :span="12">
            <el-form-item
              label="宽(cm)"
              prop="ProductWidth"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductWidth"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="Fragile"
              label="是否易碎"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >

            <el-select v-model="addForm.Fragile" >
                <el-option
                v-for="item in options_fragile"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
                 
                </el-select>   
             
            </el-form-item>
          </el-col>
        </el-row> 
        
         <el-row>
          <el-col :span="12">
            <el-form-item
              label="高(cm)"
              prop="ProductHight"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductHight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="IsSaleCertificate"
              label="需要认证"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
            <el-select v-model="addForm.IsSaleCertificate" >
            <el-option
                v-for="item in options_fragile"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>   
            </el-form-item>
          </el-col>
        </el-row> 


        <el-row>
       <el-col :span="12">
            <el-form-item
              label="产品链接"
              prop="ProductSKUUrl"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductSKUUrl"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        <el-col :span="12">
            <el-form-item
              label="包裹类型"
              prop="PackageType"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.PackageType"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        </el-card>

  <!-- 关务信息 -->
      <el-card shadow="hover" style="margin-top:10px;width:100%;">
        <div slot="header" class="clearfix" >
          <span>关务信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="海关编码"
              prop="HSCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.HSCode"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="DeclareCurrent"
              label="申报币别"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
        <el-select v-model="addForm.DeclareCurrent" >
           <el-option
                        v-for="item in currencyList"
                        :label="item.currencyName"
                        :value="item.currencyValue"
                        :key="item.currencyValue"
                    ></el-option>
        </el-select>   
         

            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
          <el-col :span="12">
            <el-form-item
              label="申报名称"
              prop="DeclaredName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.DeclaredName"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="Material"
              label="材质"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="addForm.Material"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
  <el-col :span="12">
            <el-form-item
              label="申报价值"
              prop="DeclaredValue"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.DeclaredValue"
                auto-complete="off"
                placeholder="保留2位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="ProductUse"
              label="用途"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="addForm.ProductUse"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>   

         <el-row>
  <el-col :span="12">
            <el-form-item
              label="单位"
              prop="ProductUnit"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.ProductUnit"
                auto-complete="off"
                placeholder=""
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="MadeOrigin"
              label="原产国"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="addForm.MadeOrigin"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row> 
      </el-card>


<!-- 说明 -->
    <el-card shadow="hover" style="margin-top:10px;width:100%;">
      <div slot="header" class="clearfix" >
        <span>说明</span>
      </div>
      <el-row>
          <el-col :span="22">
            <el-form-item
              label="备注"
              prop="Remark"
              class="labelcall"
              label-width="120px"
            >
              <el-input  type="textarea"
                v-model="addForm.Remark"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>
    </el-card>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-show="false" type="primary" @click="addSubmit(20)" :loading="addCheckLoading">提交审核</el-button>
        <el-button type="primary"  :loading="addDraffLoading" @click="addSubmit(10)">保存</el-button>
        <el-button @click="addFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  
      <el-dialog title="附件管理" :visible.sync="attachFormVisible" :close-on-click-modal="false">
             <el-form
        :model="attachForm"
        label-width="80px"
        :rules="attachFormRules"
        ref="attachForm"
        >
          <el-row type="flex" class="row-bg" style="text-align: center">
        <el-form-item label="附件类型"   prop="attachType">
                <el-select v-model="attachForm.attachType">
                   <el-option
                v-for="item in options_attachType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
                </el-select>   
                
        </el-form-item>
        <el-form-item label="附件说明"  prop="attachNotes">
             <el-input 
                     v-model="attachForm.attachNotes"
                     auto-complete="off" placeholder="输入附件说明" 
              ></el-input>
        </el-form-item>
          </el-row>

  <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
               :file-list="fileList"
              :before-upload="onBeforeUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div> -->
            </el-upload>
          </el-form-item>
        </el-row>
           <el-table
      :data="attachtableData" border
      style="width: 100%">
      <el-table-column
        prop="attachName"
        label="附件名"
        width="180">

        <template slot-scope="scope">
            <el-button @click="DownloadProductSKUAttachBtn(scope.row.attachUrl,scope.row.attachName)"  type="text" size="small">{{scope.row.attachName}}</el-button>
      </template>
      </el-table-column>
      <el-table-column
        prop="attachTypeDesc"
        label="附件类型"
        width="180">
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="上传人">

      </el-table-column>
      <el-table-column
        prop="createTimeDesc"
        label="上传时间">
      </el-table-column>

       <el-table-column
      fixed="right"
      label="操作"
      width="140">
      <template slot-scope="scope">
        <el-button @click="DeleteProductSKUAttach(scope.row.productSKUAttachId,1)"  v-if="$hasRight(buttonList,'Product:ProductSKUAttach:DeleteSelf')" type="text" size="small">删除</el-button>
                <el-button @click="DeleteProductSKUAttach(scope.row.productSKUAttachId,0)"  v-if="$hasRight(buttonList,'Product:ProductSKUAttach:DeleteAll')" type="text" size="small">删除(所有)</el-button>
      </template>
    </el-table-column>
    </el-table>

  <el-row>
    
  </el-row>
     </el-form>
      </el-dialog>

   <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
             <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
  <!-- 基本信息 -->
    <el-card shadow="hover" style="width:100%;">
      <div slot="header" class="clearfix" >
      <span>基本信息</span>
    </div>
       <el-row>
          <el-col :span="20">
            <el-form-item v-show="EditConsumerVisible"
              label="客户"
              prop="orgId"
              class="labelcall"
              label-width="120px"
            >
              <el-input v-show="false"
                v-model="editForm.productId"
                auto-complete="off"
              ></el-input>
              <el-select v-model="editForm.orgId"  placeholder="请选择客户"  disabled >
                    <el-option
                        v-for="item in customerList"
                        :label="item.customName"
                        :value="item.id"
                        :key="item.id"
                    ></el-option>
                    </el-select>
            </el-form-item>
          </el-col>
        
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="sku"
              prop="sku"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.sku"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50" disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="skuBarCode"
              label="条码"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="editForm.skuBarCode"
                auto-complete="off"
                placeholder="50字符以内" disabled
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>

    <el-row>
       <el-col :span="20">
            <el-form-item
              label="参考编号"
              prop="referenceNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.referenceNumber"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>

        
        </el-row>


    <el-row>
       <el-col :span="20">
            <el-form-item
              label="名称【中文】"
              prop="productNameCN"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productNameCN"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>

<el-row>
       <el-col :span="20">
            <el-form-item
              label="名称【英文】"
              prop="productNameEN"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productNameEN"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>
    </el-card>

  <el-card shadow="hover" style="margin-top:10px;width:100%;">
    <div slot="header" class="clearfix" >
      <span>基本属性</span>
    </div>
    <el-row>
          <el-col :span="12">
            <el-form-item
              label="品牌"
              prop="brand"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.brand"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="netWeight"
              label="净重(kg)"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="editForm.netWeight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>    

          <el-row>
          <el-col :span="12">
            <el-form-item
              label="型号"
              prop="model"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.model"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="productWeight"
              label="毛重(kg)"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="editForm.productWeight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> 


             <el-row>
          <el-col :span="12">
            <el-form-item
              label="长(cm)"
              prop="productLength"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productLength"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="salesStatus"
              label="销售状态"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
           <el-select v-model="editForm.salesStatus" placeholder="请选择">
                <el-option
                v-for="item in options_salesStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
          </el-select>
            </el-form-item>
          </el-col>
        </el-row> 
         <el-row>
          <el-col :span="12">
            <el-form-item
              label="宽(cm)"
              prop="productWidth"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productWidth"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="fragile"
              label="是否易碎"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >

            <el-select v-model="editForm.fragile" >
                  <el-option
                v-for="item in options_fragile"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
                   
                </el-select>   
             
            </el-form-item>
          </el-col>
        </el-row> 
        
         <el-row>
          <el-col :span="12">
            <el-form-item
              label="高(cm)"
              prop="productHight"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productHight"
                auto-complete="off"
                placeholder="保留3位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
               prop="isSaleCertificate"
              label="需要认证"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
            <el-select v-model="editForm.isSaleCertificate" >
                  <el-option
                v-for="item in options_fragile"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
         
        </el-select>   
            </el-form-item>
          </el-col>
        </el-row> 


        <el-row>
       <el-col :span="12">
            <el-form-item
              label="产品链接"
              prop="productSKUUrl"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productSKUUrl"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        <el-col :span="12">
            <el-form-item
              label="包裹类型"
              prop="packageType"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.packageType"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
  </el-card>
 
  <!-- 关务信息 -->

  <el-card shadow="hover" style="margin-top:10px;width:100%">
    <div slot="header" class="clearfix" >
      <span>关务信息</span>
    </div>
     <el-row>
          <el-col :span="12">
            <el-form-item
              label="海关编码"
              prop="hsCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.hsCode"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="declareCurrent"
              label="申报币别"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
  <el-select v-model="editForm.declareCurrent" >
            <el-option
                        v-for="item in currencyList"
                        :label="item.currencyName"
                        :value="item.currencyValue"
                        :key="item.currencyValue"
                    ></el-option>
        </el-select>   

            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
          <el-col :span="12">
            <el-form-item
              label="申报名称"
              prop="declaredName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.declaredName"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="material"
              label="材质"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="editForm.material"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
  <el-col :span="12">
            <el-form-item
              label="申报价值"
              prop="declaredValue"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.declaredValue"
                auto-complete="off"
                placeholder="保留2位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="productUse"
              label="用途"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="editForm.productUse"
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>   

         <el-row>
  <el-col :span="12">
            <el-form-item
              label="单位"
              prop="productUnit"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.productUnit"
                auto-complete="off"
                placeholder=""
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="madeOrigin"
              label="原产国"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="editForm.madeOrigin"
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row> 
  </el-card>


<!-- 说明 -->
  <el-card shadow="hover" style="margin-top:10px;width:100%;">
    <div slot="header" class="clearfix" >
      <span>说明</span>
    </div>
    <el-row>
      <el-col :span="22">
        <el-form-item
          label="备注"
          prop="remark"
          class="labelcall"
          label-width="120px"
        >
          <el-input  type="textarea"
            v-model="editForm.remark"
            auto-complete="off"
            placeholder="200字符以内"
            maxlength="200"
          ></el-input>
        </el-form-item>
      </el-col>
    
    </el-row>
  </el-card>
<!-- <fieldset>
    <legend>说明</legend>
 <el-row>
          <el-col :span="22">
            <el-form-item
              label="备注"
              prop="remark"
              class="labelcall"
              label-width="120px"
            >
              <el-input  type="textarea"
                v-model="editForm.remark"
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>

</fieldset> -->
   <!-- <div>

        <el-row style="text-align:right;margin-top:20px;margin-right:20px">      
          <el-col :span="24">
            <el-form-item>

                <el-button @click="editFormVisible = false">关闭</el-button>
               <el-button type="primary"  :loading="editLoading" @click="editSubmit()">修改</el-button>
            </el-form-item>
          </el-col>
         
        </el-row>

        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">关闭</el-button>
        <el-button type="primary"  :loading="editLoading" @click="editSubmit()">修改</el-button>
      </div>

        </el-dialog>



 <!--关务信息-->
        <el-dialog title="关务信息" :visible.sync="HSCodeFormVisible" v-model="HSCodeFormVisible" :close-on-click-modal="false">
             <el-form
        :model="HSCodeForm"
        label-width="80px"
        ref="editForm"
      >
  <!-- 关务信息 -->

  <el-card shadow="hover" style="margin-top:10px;width:100%">
    <div slot="header" class="clearfix" >
      <span>关务信息</span>
    </div>
     <el-row>
          <el-col :span="12">
            <el-form-item
              label="海关编码"
              prop="hsCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="HSCodeForm.hsCode"
                auto-complete="off"
                placeholder="30字符以内" disabled
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="declareCurrent"
              label="申报币别"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
  <el-select v-model="HSCodeForm.declareCurrent"  disabled>
            <el-option
                        v-for="item in currencyList"
                        :label="item.currencyName"
                        :value="item.currencyValue"
                        :key="item.currencyValue"
                    ></el-option>
        </el-select>   

            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
          <el-col :span="12">
            <el-form-item
              label="申报名称"
              prop="declaredName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="HSCodeForm.declaredName" disabled
                auto-complete="off"
                placeholder="200字符以内"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="material"
              label="材质"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="HSCodeForm.material" disabled
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>    

 <el-row>
  <el-col :span="12">
            <el-form-item
              label="申报价值"
              prop="declaredValue"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="HSCodeForm.declaredValue" disabled
                auto-complete="off"
                placeholder="保留2位小数"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="productUse"
              label="用途"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="HSCodeForm.productUse" disabled
                auto-complete="off"
                placeholder="100字符以内"
                maxlength="100"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row>   

         <el-row>
  <el-col :span="12">
            <el-form-item
              label="单位"
              prop="productUnit"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="HSCodeForm.productUnit" disabled
                auto-complete="off"
                placeholder=""
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="madeOrigin"
              label="原产国"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
             <el-input
                v-model="HSCodeForm.madeOrigin" disabled
                auto-complete="off"
                placeholder="30字符以内"
                maxlength="50"
              ></el-input>
             
            </el-form-item>
          </el-col>
        </el-row> 
  </el-card>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="HSCodeFormVisible = false">关闭</el-button>
      </div>

        </el-dialog>




<el-dialog :title="dialogSetAlias" :visible.sync="dialogSetAliasVisible" >
  <el-form :model="setAliasForm"  :rules="setAliasFormRules"
        ref="setAliasForm">

    <el-form-item label="输入别名"  
              prop="skuAliasCodes"
              class="labelcall"
              label-width="120px">
      <el-input v-model="setAliasForm.skuAliasCodes" autocomplete="off"  placeholder="多个别名以英文逗号分隔如:A01,A02,A03"></el-input>
    </el-form-item>
    
     <el-row style="text-align:right;margin-top:20px;margin-right:20px">      
          <el-col :span="24">
            <el-form-item>
            <el-button @click="dialogSetAliasVisible = false">取 消</el-button>
            <el-button type="primary" @click="setAliasSubmit()">确 定</el-button>
            </el-form-item>
          </el-col>
         
        </el-row>

  </el-form>
  <div slot="footer" class="dialog-footer">
    
  </div>
</el-dialog>

  </div>

</template>

<script>
    import util from '../../../util/date'
    import { getProductSKUList,getCustomerList,AddProductSKU,EditProductSKU,DeleteProductSKU,AuditProductSKU,SetProductSKUAlias,
    GetProductSKUAliasList,GetProductSkuAttachList,ImportProductSKUAttachFile,DeleteProductSKUAttach,DownloadProductSKUAttach,GetCurrencyList} from '@/api/ProductSku.js';
    import { getButtonList } from "../../promissionRouter";
    import Toolbar from "../../components/Toolbar";
    import axios from "axios";

    export default {
        components: { Toolbar },
        data() {

            var price = (rule, value, callback) => {
                const reg = /^\d+.?\d{0,2}$/
                if (!value) {
                    callback(new Error('请输入数字'))
                } else if (!Number(value)) {
                    callback(new Error('请输入数字值'))
                }
                  else if (parseFloat(value).toFixed(2) > 9999999.99) {
                  callback(new Error("最大值为9999999.99"));
                }  
                else {
                    if (reg.test(value)) {
                    callback()
                    } else {
                    callback(new Error('小数点后最多只能输入2位'))
                    }
                }
                }
            var shenbaoValue=(rule, value, callback) => {
                const reg = /^\d+.?\d{0,2}$/
                if (!value) {
                    callback(new Error('请输入申报价值'))
                } else if (!Number(value)) {
                    callback(new Error('请输入申报价值'))
                }
                  else if (parseFloat(value).toFixed(2) > 9999999.99) {
                  callback(new Error("最大值为9999999.99"));
                }  
                else {
                    if (reg.test(value)) {
                    callback()
                    } else {
                    callback(new Error('小数点后最多只能输入2位'))
                    }
                }
                }

             var numberlimit = (rule, value, callback) => {
                const reg = /^\d+.?\d{0,3}$/
                if (!value) {
                    callback(new Error('请输入数字'))
                } else if (!Number(value)) {
                    callback(new Error('请输入数字值'))
                } 
                else if (parseFloat(value).toFixed(2) > 9999999.99) {
                  callback(new Error("最大值为9999999.99"));
                } 
                else {
                    if (reg.test(value)) {
                    callback()
                    } else {
                    callback(new Error('小数点后最多只能输入3位'))
                    }
                }
              
                }
            return {
                attachFormVisible:false,
                attachFormRules:{
                     attachType: [
                       
                         { required: true, message: "请选择附件类型", trigger: "change" },
                     ],
                    //  attachNotes: [
                    //     { required: true, message: '请输入附件说明', trigger: 'blur'},
                    //     { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    // ],
                },
                fileList:[],
                attachfilters:{},
                attachForm:{attachType:1,attachNotes:''},
                buttonList: [],
                currentRow: null,
                tableHeight: 0,
                filters: {
                    keyword: '',
                    enabled: '',
                    
                },
                options_fragile:[{
                    value: true,
                    label: '是'
                    }, {
                    value: false,
                    label: '否'
                    }],

            options_attachType:[{
                    value: 1,
                    label: '认证文件'
                    }, {
                    value: 2,
                    label: '其他'
                    }],
                options_salesStatus:[{
                    value: 10,
                    label: '新品'
                    }, {
                    value: 20,
                    label: '正常'
                    }, {
                    value: 30,
                    label: '清货'
                    }, {
                    value: 40,
                    label: '停售'
                    }],
                searchConsumerVisible:false,
                EditConsumerVisible:false,
                tablelist: [],
                attachtableData:[],
                customerList:[],
                customerEnabledList:[],
                currencyList:[],
                dialogSetAlias:"设置别名",
                typeList: [{text: '客户', value: 10},{text: '服务商', value: 20}],
                typeVisible: false,
                statusList: [{text: '正常', value: true}, {text: '禁用', value: false}],
                total: 0,
                page: 1,
                flag:false,
                pageSize: 50,
                listLoading: false,
                sels: [],//列表选中列
                HSCodeForm:{},
                addDialogFormVisible: false,
                editFormVisible: false,//编辑界面是否显示
                HSCodeFormVisible:false,
                editLoading: false,
                dialogSetAliasVisible:false,
                setAliasForm:{},
                setAliasFormRules:{
                     skuAliasCodes: [
                        { required: true, message: '请输入别名', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                },
                editFormRules: {
                    sku: [
                        { required: true, message: '请输入SKU', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    skuBarCode: [
                        { required: true, message: '请输入条码', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    productNameCN: [
                        { required: true, message: '请输入中文名', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                    netWeight: [
                        { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    productWeight: [
                          { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    productLength: [
                        { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    productWidth: [
                      { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    productHight: [
                       { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    salesStatus: [
                       
                         { required: true, message: "请选择销售状态", trigger: "change" },
                    ],
                    fragile: [
                        { required: true, message: '请选择易碎状态', trigger: 'change' }
                    ],
                    isSaleCertificate: [
                        {  required: true, message: '请选择认证状态', trigger: 'change' }
                    ],
                    madeOrigin:
                    [
                        { required: true, message: '请输入原产国', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    declaredValue: [
                       { required: true, validator:shenbaoValue,trigger: 'blur'},
                    ],   
                    packageType: [
                        { required: true, message: '请输入包裹类型', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                    productSKUUrl: [
                        { required: true, message: '请输入产品销售链接', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                    hsCode:
                    [
                        { required: true, message: '请输入海关编码', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                     declareCurrent:
                    [
                       {  required: true, message: '请选择申报币别', trigger: 'change' }
                          
                    ],

                    declaredName:
                    [
                        { required: true, message: '请输入申报名称', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                    material:
                    [
                        { required: true, message: '请输入材质', trigger: 'blur'},
                        { min: 1, max: 100, message: '最多100个字符', trigger: 'blur' }
                    ],
                    productUse:
                    [
                        { required: true, message: '请输入用途', trigger: 'blur'},
                        { min: 1, max: 100, message: '最多100个字符', trigger: 'blur' }
                    ],
                    
                   

                    productUnit :
                    [
                        { required: true, message: '请输入单位 ', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                },
                //编辑界面数据
                editForm: {
                   
                },
                addFormVisible: false,//新增界面是否显示
                addCheckLoading: false,
                addDraffLoading:false,
                addFormRules: {

                    SKU: [
                        { required: true, message: '请输入SKU', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    SKUBarCode: [
                        { required: true, message: '请输入条码', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    ProductNameCN: [
                        { required: true, message: '请输入中文名', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                    NetWeight: [
                        { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    ProductWeight: [
                          { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    ProductLength: [
                        { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    ProductWidth: [
                      { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    ProductHight: [
                       { required: true, validator:numberlimit,trigger: 'blur'},
                    ],
                    SalesStatus: [
                       
                         { required: true, message: "请选择销售状态", trigger: "change" },
                    ],
                    Fragile: [
                        { required: true, message: '请选择易碎状态', trigger: 'change' }
                    ],
                    IsSaleCertificate: [
                        {  required: true, message: '请选择认证状态', trigger: 'change' }
                    ],
                    MadeOrigin:
                    [
                        { required: true, message: '请输入原产国', trigger: 'blur'},
                        { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
                    ],
                    DeclaredValue: [
                       { required: true, validator:shenbaoValue,trigger: 'blur'},
                    ],   
                    PackageType: [
                        { required: true, message: '请输入包裹类型', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                    ProductSKUUrl: [
                        { required: true, message: '请输入产品销售链接', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                    HSCode:
                    [
                        { required: true, message: '请输入海关编码', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                     DeclareCurrent:
                    [
                       {  required: true, message: '请选择申报币别', trigger: 'change' }
                          
                    ],

                    DeclaredName:
                    [
                        { required: true, message: '请输入申报名称', trigger: 'blur'},
                        { min: 1, max: 200, message: '最多200个字符', trigger: 'blur' }
                    ],
                     Material:
                    [
                        { required: true, message: '请输入材质', trigger: 'blur'},
                        { min: 1, max: 100, message: '最多100个字符', trigger: 'blur' }
                    ],
                     ProductUse:
                    [
                        { required: true, message: '请输入用途', trigger: 'blur'},
                        { min: 1, max: 100, message: '最多100个字符', trigger: 'blur' }
                    ],
                    
                     MadeOrigin :
                    [
                        { required: true, message: '请输入原产国 ', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],

                      ProductUnit :
                    [
                        { required: true, message: '请输入单位 ', trigger: 'blur'},
                        { min: 1, max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],

                    
                    
                },
                //新增界面数据
                addForm: { 
                  Fragile:false,
                  IsSaleCertificate:false,
                  SalesStatus:10
                }

            }
        },
        methods: {
            selectCurrentRow(val) {
                  this.currentRow = val;
                 
                
                this.$refs.multipleTable.toggleRowSelection(val);
            },
                 //点击行触发，选中或不选中复选框
        handleRowClick(row, column, event){
          this.flag = !this.flag; 
          this.$refs.multipleTable.toggleRowSelection(row,this.flag);
        },
            manageAttach(productId){
                this.attachFormVisible=true;
                this.attachForm.productId=productId;
                this.initProductSkuAttachList(productId);
            },

               //文件上传前验证
      onBeforeUpload(file) {
        
        var flag=false;
        if(this.attachForm.attachType==2){

             if(this.attachForm.attachNotes==null||this.attachForm.attachNotes==''){
                  this.$message({
                                message:'附件类型为：其他=>请输入附件说明!',
                                type: "error",
                              });
                                 return false;
             }
             else if(this.attachForm.attachNotes.length>50){
              this.$message({
                                message:'附件说明长度超过50',
                                type: "error",
                              });
                                 return false;
             }
             
        }else{

   

          if(this.attachForm.attachNotes!=null&&this.attachForm.attachNotes!=''){
             if(this.attachForm.attachNotes.length>50){
              this.$message({
                                message:'附件说明长度超过50',
                                type: "error",
                              });
                                 return false;
             }
          }
           
        }
        
        this.$refs.attachForm.validate((valid) => {
                    
                    if (valid) {
                    flag=true;
                    }
                    });
                    if(!flag){
        return false;
                    }
      },

            //上传文件
    UploadExcel(param) {

      console.log(param, "文件");
      let para = new FormData();
      para.append("file", param.file);
      para.append("attachType", this.attachForm.attachType);
      para.append("attachNotes", this.attachForm.attachNotes);
      para.append("productId", this.attachForm.productId);
      
      this.progressFlag = true;
      var _this = this;
    
                        axios({
                          url: ImportProductSKUAttachFile,
                          method: "post",
                          data: para,
                          headers: { "Content-Type": "multipart/form-data" },
                          onUploadProgress: (progressEvent) => {
                            // progressEvent.loaded:已上传文件大小
                            // progressEvent.total:被上传文件的总大小
                            //进度条
                            this.progressPercent =
                              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
                          },
                        })
                          .then((res) => {
                            if (res.data.success) {
                              this.initProductSkuAttachList(this.attachForm.productId);
                              param.onError(); // 上传成功的文件会显示绿色的对勾
                              this.importVisible = false;
                              this.$message({
                                message: res.data.msg,
                                type: "success",
                              });
                              
                            } else {
                              this.$message({
                                message: res.data.msg+"请修改数据重新导入",
                                type: "error",
                              });
                              param.onError();
                            }
                            this.progressFlag = false;
                            this.progressPercent = 0;
                          })
                          .catch((error) => {
                            this.progressFlag = false;
                            this.progressPercent = 0;
                            this.$message({
                              message: "文件导入失败，请重试",
                              type: "error",
                            });
                            param.onError();
                      });
    

    
    },
            callFunction(item) {
            // this.filters = {
            //     keyword: item.search
            // };
            // this[item.func].apply(this, item);
              this.newfilters =JSON.parse(JSON.stringify(this.filters)) 
              this[item.func].apply(this, [item]);
            },
            formatCreateTime: function (row, column) {
                return (!row.createTime || row.createTime == '') ? '' : util.formatDate.format(new Date(row.createTime), 'yyyy-MM-dd');
            },
            
            format_createInfo:function(row,column){
                return  "创建用户:"+row.createUser;
                //+"<br/> 创建时间:"+(!row.createTime || row.createTime == '') ? '' : util.formatDate.format(new Date(row.createTime), 'yyyy-MM-dd')+"</span>";
            },
            format_updateInfo:function(row,column){
                return  "修改用户:"+row.lastUpUser;
                //+"<br/> 修改时间:"+(!row.LastUpTime || row.LastUpTime == '') ? '' : util.formatDate.format(new Date(row.LastUpTime), 'yyyy-MM-dd');
            },
            format_checkInfo:function(row,column){
                return  "审核用户:"+row.checkUser;
                //+"<br/> 审核时间:"+(!row.CheckTime || row.CheckTime == '') ? '' : util.formatDate.format(new Date(row.CheckTime), 'yyyy-MM-dd');
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.GetProductSKUList();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.GetProductSKUList();
            },
            //获取接口列表
            GetProductSKUList(item) {
                toString.call(item) === "[object Object]" ? (this.page = 1) : this.page;
                let para = {
                    page: this.page,
                    pageSize: this.pageSize,
                    Skus: this.newfilters.Skus,
                    ProductName: this.newfilters.ProductName,
                    ProductStatus: this.newfilters.ProductStatus,
                    Brand: this.newfilters.Brand,
                    CustomerIds: this.newfilters.CustomerIds,
                };
                this.listLoading = true;
                console.info(para);
                //NProgress.start();
                getProductSKUList(para).then((res) => {
                    this.total = res.data.response.total;
                    this.tablelist = res.data.response.pageData;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            GetCustomerDrowList(){
                let para = {
                    SupplierId:0,
                     IsAll:true
                };
                getCustomerList(para).then((res) => {
                    this.customerList= res.data.response;

                });
            },
           
          GetEnableCustomerDrowList(){
                let para = {
                    IsAll:false
                };
                getCustomerList(para).then((res) => {
                    this.customerEnabledList= res.data.response;

                });
            },
           

           GetCurrencyList(){
                let para = {
                   
                };
                GetCurrencyList(para).then((res) => {
                    this.currencyList= res.data.response;

                });
              },
            //删除
            handleDel() {
                  let row = this.sels;
                if (!row||row.length<=0) {
                    this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error"
                    });

                    return;
                }
                this.$confirm('确认删除SKU数据?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    //NProgress.start();
                
                    DeleteProductSKU(row).then((res) => {

                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        //NProgress.done();
                        if (res.data.response) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });

                        } else {
                            this.$message({
                                message: "删除失败!",
                                type: 'error'
                            });
                        }

                        this.GetProductSKUList();
                    });
                }).catch(() => {

                });
            },
            handleAudit() {
                let row = this.sels;
                if (!row||row.length<=0) {
                    this.$message({
                        message: "请选择一行数据！",
                        type: "error"
                    });

                    return;
                }
               
               var isNoauid=false;
                row.forEach((item) => {
                  
                  if (item.productStatus==20||item.productStatus==30) {
                    isNoauid=true;
                    
                    
                  }
                  
                });
               
                if(isNoauid==true){
                   this.$message({
                      message: "草稿单据才能审核！",
                      type: "error",
                    });
                   return;
                 
                }
               
                const loading = this.$loading({
                lock: true,
                text: '审核中，请稍等',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
              });

                AuditProductSKU(row).then((res) => {
                  loading.close();
                    if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        //NProgress.done();
                        if (res.data.success) {
                            this.$message({
                                message: '审核成功',
                                type: 'success'
                            });

                        } else {
                            this.$message({
                                message: "审核失败!"+res.data.msg,
                                type: 'error'
                            });
                        }

                        this.GetProductSKUList();
                });
            },
            handleSetAlias() {
                let row ={};
                 
                if(this.sels==null||this.sels.length==0){
                  this.$message({
                    message: "请选择一行数据！",
                    type: "error"
                    });

                    return;
                }
                if(this.sels!=null&&this.sels.length>1){
                    this.$message({
                    message: "请选择一行数据,不能多选！",
                    type: "error"
                    });

                    return;
                 }
               
                if(this.sels!=null&&this.sels.length===1){
                        
                          row=this.sels[0];
                         
                    }else{
                       this.$message({
                        message: "请选择一行数据！",
                        type: "error"
                        });

                      return;

                    }

                   
               
                

                this.editForm = Object.assign({}, row);

               
                let para = Object.assign({}, this.editForm);

               //this.setAliasForm.skuAliasCode="ddddd";
               this.setAliasForm.skuAliasCodes="";

               this.dialogSetAlias="设置别名【SKU:"+row.sku+"】";
               this.initProductSKUAliasList(para.productId);
               this.dialogSetAliasVisible = true;
            },

            ShowHSCodeForm(row){
             this.HSCodeForm = Object.assign({}, row);
                console.log(JSON.stringify(this.HSCodeForm));

                  this.HSCodeFormVisible = true;
            },
            //显示编辑界面
            handleEdit() {
            
               let row ={};
                 
                if(this.sels==null||this.sels.length==0){
                  this.$message({
                    message: "请选择一行数据！",
                    type: "error"
                    });

                    return;
                }
                if(this.sels!=null&&this.sels.length>1){
                    this.$message({
                    message: "请选择一行数据,不能多选！",
                    type: "error"
                    });

                    return;
                 }
               
                if(this.sels!=null&&this.sels.length===1){
                        
                          row=this.sels[0];
                         
                    }else{
                       this.$message({
                        message: "请选择一行数据！",
                        type: "error"
                        });

                      return;

                    }

                

                  var user = JSON.parse(window.localStorage.user);
                  if (user && user.id > 0){
                    if(user.organizationType===20||user.organizationType===30){
                     
                     if(user.organizationType===20){
                            if(user.organizationId===row.orgId&&row.type==20){
                                this.EditConsumerVisible=false;
                            }else{
                              this.EditConsumerVisible=true;
                           }
                     }
                     
                     
                    }
                    
                  }
                 this.GetCurrencyList();
              
                this.editForm = Object.assign({}, row);
                console.log(JSON.stringify(this.editForm));

                  this.editFormVisible = true;
               
            },
            //显示新增界面
            handleAdd() {
                this.GetCurrencyList();
                this.GetEnableCustomerDrowList();
                this.addForm={
                  Fragile:false,
                  IsSaleCertificate:false,
                  SalesStatus:10};
                this.addFormVisible = true;
                this.$refs.addForm.clearValidate();
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            
                             EditProductSKU(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.response.success) {
                                     this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.response.msg,
                                        type: 'success'
                                    });
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.GetProductSKUList();
                                }
                                else {
                                    this.$message({
                                        message: res.data.response.msg,
                                        type: 'error'
                                    });
                                    this.editLoading = false;

                                }

                            });

                        });
                    }
                });
            },
             DownloadProductSKUAttachBtn(url,filename){
            
             

              DownloadProductSKUAttach(url,filename);

             },

            DeleteProductSKUAttach(productSKUAttachId,IsSelf){
             
             this.$confirm('确认删除文件?', '提示', {
                    type: 'warning'
                }).then(() => {
            if(productSKUAttachId==null||productSKUAttachId==""){
                   this.$message({
                                        message: "删除失败,改附件不存在！",
                                        type: 'error'
                                    });
               }else{
                   var para={productSKUAttachId:productSKUAttachId,IsSelf:IsSelf};
                   DeleteProductSKUAttach(para).then((res) => {
                                if (res.data.success) {
                                   this.$message({
                                        message: "删除成功",
                                        type: 'success'
                                    });
                                   this.initProductSkuAttachList(this.attachForm.productId);
                                }
                                else {
                                    this.$message({
                                        message: "删除失败"+res.data.msg,
                                        type: 'error'
                                    });
                                   
                                }

                            });

               }
                });

              
            },
            setAliasSubmit:function(){
                let _this = this;

               
                this.$refs.setAliasForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {

                                let para = Object.assign({}, this.editForm);
                                console.log(JSON.stringify(para));
                                
                            this.setAliasForm.ProductSKUId=para.productId;
                        
                             SetProductSKUAlias(this.setAliasForm).then((res) => {
                                
                                if (res.data.success) {
                                    
                                    this.$message({
                                        message: "设置成功",
                                        type: 'success'
                                    });
                                    this.$refs['setAliasForm'].resetFields();
                                    this.dialogSetAliasVisible = false;
                                    this.GetProductSKUList();
                                }
                                else {
                                    this.$message({
                                        message: "设置失败："+res.data.msg,
                                        type: 'error'
                                    });
                                   
                                }

                            });

                        });
                    }
                });
            },
            //新增
            addSubmit: function (productStatus) {
                let _this = this;
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            if(productStatus==20)this.addCheckLoading = true;
                            if(productStatus==10)this.addDraffLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            para.createTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');
                            para.modifyTime = para.createTime;
                            para.isDeleted = false;
                            para.productStatus=productStatus;

                            var user = JSON.parse(window.localStorage.user);

                            if (user && user.id > 0) {
                                console.info(user);
                                para.createId = user.id;
                                para.createBy = user.realName;
                                para.parentId = user.organizationId;
                               
                            } else {
                                this.$message({
                                    message: '用户信息为空，先登录',
                                    type: 'error'
                                });
                                _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
                            }
                            

                           AddProductSKU(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                     if(productStatus==20)this.addCheckLoading = false;
                                     if(productStatus==10)this.addDraffLoading = false;
                                    return;
                                }
                                if (res.data.response.success) {
                                     if(productStatus==20)this.addCheckLoading = false;
                                     if(productStatus==10)this.addDraffLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.response.msg,
                                        type: 'success'
                                    });
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.GetProductSKUList();
                                }
                                else {
                                    this.$message({
                                        message: res.data.response.msg,
                                        type: 'error'
                                    });
                                     if(productStatus==20)this.addCheckLoading = false;
                                     if(productStatus==10)this.addDraffLoading = false;

                                }

                            });

                        });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            initVisibleCustomName:function(){
                  var user = JSON.parse(window.localStorage.user);
                  if (user && user.id > 0){
                    this.searchConsumerVisible = user.organizationType===20||user.organizationType===30;
                  }
            },
            initProductSKUAliasList:function(ProductSKUId){

               var para={ProductSKUId:ProductSKUId};
                GetProductSKUAliasList(para).then((res) => {
                    if(res.data.response!=null){

                        var stuAliasListData=res.data.response;
                        var aliasCodes="";
                       for(var i=0;i<stuAliasListData.length;i++){ 
                           aliasCodes+=stuAliasListData[i].skuAliasCode+",";
                           
                        }
  
                        if(aliasCodes!=null||aliasCodes!=""){
                        
                          aliasCodes=aliasCodes.slice(0,-1);
                        }
                        this.setAliasForm=Object.assign({}, {skuAliasCodes:aliasCodes,ProductSKUId:ProductSKUId});
                        
                    }
                    

                });
            },

            initProductSkuAttachList:function(ProductSKUId){
              var para={ProductSKUId:ProductSKUId};
                GetProductSkuAttachList(para).then((res) => {
                    if(res.data.response!=null){

                        this.attachtableData=res.data.response;
                    }
                    

                });
            }

        },
        created(){
          //this.attachForm.attachType=1;
        },
        mounted() {

            this.initVisibleCustomName();

            this.GetCustomerDrowList();

            

            //this.GetProductSKUList();

            let user = JSON.parse(window.localStorage.user);
            console.info(user)
            this.typeVisible = user.isSa;

            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
        }
    }

</script>

<style scoped>
  fieldset {
 border: 1px solid #DCDFE6;
  }
  
</style>